import { axiosGet } from "../../react_axios/Axios"
import { GET_REPORT_DETAIL, getReportListUrl, GET_REPORT_LIST, headers, reportDetailListUrl, getDynamicReportUrl, GET_DYNAMIC_REPORT, getDynamicFillListUrl, GET_DYNAMIC_FILLLIST } from "../../utils/constants"

export const get_report_list_action = () => async (dispatch) => {
    try {
        const mapdata = {
            role_id: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID ? JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID : null,
        }
        const res = await axiosGet(getReportListUrl, mapdata, headers);

        dispatch({
            type: GET_REPORT_LIST,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_report_details_action = (report_id) => async (dispatch) => {
    try {
        const mapdata = {
            role_id: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID ? JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID : null,
            report_id: report_id
        }
        const res = await axiosGet(reportDetailListUrl, mapdata, headers);

        dispatch({
            type: GET_REPORT_DETAIL,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const get_dynamic_report_action = (report_sp, selectedParams) => async (dispatch) => {
    try {
        const mapdata = {
            role_id: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID ? JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID : null,
            report_sp: report_sp,
            selectedParams: selectedParams
        }
        const res = await axiosGet(getDynamicReportUrl, mapdata, headers);

        dispatch({
            type: GET_DYNAMIC_REPORT,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const get_dynamic_fillList_action = (parameterSP) => async (dispatch) => {
    try {
        const mapdata = {
            role_id: sessionStorage.getItem('loginDataSS') && JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID ? JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID : null,
            parameterSP: parameterSP
        }
        const res = await axiosGet(getDynamicFillListUrl, mapdata, headers);

        dispatch({
            type: GET_DYNAMIC_FILLLIST,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};